module.exports = __webpack_public_path__ + "static/img/home_productcard_tunnel.7ac1f7fe.jpg";